import React, { createContext, useContext, useState, ReactNode } from "react";

interface PromoContextType {
  discountPercent: number | null;
  setDiscountPercent: (discountPercent: number | null) => void;
}

const PromoContext = createContext<PromoContextType | undefined>(undefined);

export const PromoProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [discountPercent, setDiscountPercent] = useState<number | null>(null);

  return (
    <PromoContext.Provider value={{ discountPercent, setDiscountPercent }}>
      {children}
    </PromoContext.Provider>
  );
};

export const usePromo = (): PromoContextType => {
  const context = useContext(PromoContext);
  if (context === undefined) {
    throw new Error("usePromo must be used within a PromoProvider");
  }
  return context;
};
